// Small geo helpers. Pure functions, no DOM: imported by the app and by node tests.

const R = 6371008.8; // mean Earth radius, metres
const rad = (d) => (d * Math.PI) / 180;
const deg = (r) => (r * 180) / Math.PI;

/** Great-circle distance in metres. */
export function distanceM(lat1, lon1, lat2, lon2) {
  const dLat = rad(lat2 - lat1);
  const dLon = rad(lon2 - lon1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
}

/** Initial bearing from point 1 to point 2, degrees 0-360 clockwise from north. */
export function bearingDeg(lat1, lon1, lat2, lon2) {
  const y = Math.sin(rad(lon2 - lon1)) * Math.cos(rad(lat2));
  const x = Math.cos(rad(lat1)) * Math.sin(rad(lat2)) - Math.sin(rad(lat1)) * Math.cos(rad(lat2)) * Math.cos(rad(lon2 - lon1));
  return (deg(Math.atan2(y, x)) + 360) % 360;
}

const FEET_PER_M = 3.28084;
const M_PER_MILE = 1609.344;

/** "350 ft" under ~0.1 mi, otherwise "0.4 mi" / "2 mi". */
export function formatDistance(m) {
  if (m < 160) return `${Math.max(10, Math.round((m * FEET_PER_M) / 10) * 10)} ft`;
  const mi = m / M_PER_MILE;
  return `${mi < 10 ? mi.toFixed(1) : Math.round(mi)} mi`;
}

const WALK_M_PER_MIN = (3 * M_PER_MILE) / 60; // 3 mph

/** Straight-line walking estimate in whole minutes (minimum 1). Label it as an estimate in the UI. */
export const walkMinutes = (m) => Math.max(1, Math.round(m / WALK_M_PER_MIN));

/** A circle as a GeoJSON Polygon (for the location accuracy ring). */
export function circlePolygon(lat, lon, radiusM, steps = 48) {
  const ring = [];
  const dLat = deg(radiusM / R);
  const dLon = deg(radiusM / (R * Math.cos(rad(lat))));
  for (let i = 0; i <= steps; i++) {
    const t = (i / steps) * 2 * Math.PI;
    ring.push([lon + dLon * Math.cos(t), lat + dLat * Math.sin(t)]);
  }
  return { type: 'Polygon', coordinates: [ring] };
}

export const inBbox = (b, lat, lon) => lon >= b.west && lon <= b.east && lat >= b.south && lat <= b.north;
